export default "__VITE_ASSET__DEJcJ9P3__"